const deepCopyWithRecursion = (src, visited) => {
    if (typeof src === 'object' && src !== null) {
        const v = visited.get(src);
        if (v !== undefined)
            return v;
        if (Array.isArray(src)) {
            const dest = [];
            visited.set(src, dest);
            for (let i = 0; i < src.length; i += 1) {
                dest[i] = deepCopyWithRecursion(src[i], visited);
            }
            return dest;
        }
        const dest = {};
        visited.set(src, dest);
        const keys = Object.keys(src);
        for (let i = 0; i < keys.length; i += 1) {
            const k = keys[i];
            dest[k] = deepCopyWithRecursion(src[k], visited);
        }
        return dest;
    }
    if (typeof src === 'symbol')
        return Symbol(src.description);
    return src;
};
export const simpleDeepCopy = (src) => {
    if (typeof src === 'object' && src !== null) {
        if (Array.isArray(src)) {
            const dest = [];
            for (let i = 0; i < src.length; i += 1) {
                dest[i] = simpleDeepCopy(src[i]);
            }
            return dest;
        }
        const dest = {};
        const keys = Object.keys(src);
        for (let i = 0; i < keys.length; i += 1) {
            const k = keys[i];
            dest[k] = simpleDeepCopy(src[k]);
        }
        return dest;
    }
    if (typeof src === 'symbol')
        return Symbol(src.description);
    return src;
};
export const deepCopy = (src, withRecursion) => {
    if (withRecursion)
        return deepCopyWithRecursion(src, new WeakMap());
    return simpleDeepCopy(src);
};
export var AutoDestroyState;
(function (AutoDestroyState) {
    AutoDestroyState[AutoDestroyState["Disabled"] = 0] = "Disabled";
    AutoDestroyState[AutoDestroyState["Enabled"] = 1] = "Enabled";
    AutoDestroyState[AutoDestroyState["Destroyed"] = 2] = "Destroyed";
})(AutoDestroyState || (AutoDestroyState = {}));
//# sourceMappingURL=data_utils.js.map